export const ensureUser = user =>{
    const empty = { id: null, email: null, firstName: null, userType: null, isVerified: false };
    return { ...empty, ...user};
}